import React, { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { CreditForm } from '../components/credit/CreditForm';
import { StatusTracker } from '../components/credit/StatusTracker';
const howItWorks = [{
  title: 'Completás tus datos básicos',
  text: 'Sólo lo necesario: contacto, anticipo disponible y situación laboral.'
}, {
  title: 'Un analista revisa tu caso',
  text: 'Evaluamos qué alternativas de las distintas marcas se ajustan a tu perfil.'
}, {
  title: 'Te contacta un asesor',
  text: 'Te presenta opciones concretas y te acompaña con la entidad otorgante.'
}];
export function CreditCheck() {
  const [params] = useSearchParams();
  const location = useLocation();
  const code = params.get('code') ?? '';
  useEffect(() => {
    if (location.hash === '#seguimiento') {
      document.getElementById('seguimiento')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [location.hash]);
  return <div className="container-x py-8 lg:py-14" data-id="element-1325" data-mp="1bvj7s39eqwzq">
      <div className="grid gap-10 lg:grid-cols-[1fr_520px]" data-id="element-1326" data-mp="11attpphlzewd">
        <div data-id="element-1327" data-mp="1187k7kb5qpbi">
          <h1 className="font-display text-4xl font-black leading-[1] tracking-tight sm:text-5xl" data-id="element-1328" data-mp="wb7g3exvbwn1">
            CONOCÉ TUS ALTERNATIVAS PARA LLEGAR A TU <span className="text-neon" data-id="element-1329" data-mp="s8kjl0q95nji">0 KM.</span>
          </h1>
          <p className="mt-5 max-w-lg text-mist" data-id="element-1330" data-mp="nassg8xfm5gd">
            Iniciá una solicitud de evaluación preliminar. Un asesor de VCARS analiza tu caso y te propone opciones de financiación entre todas las marcas.
          </p>
          <ol className="mt-10 space-y-6 border-l border-line pl-6" data-id="element-1331" data-mp="dkhbnlsng1s2">
            {howItWorks.map(s => <li key={s.title} data-id="element-1332" data-mp="8mo70x6zvftw">
                <h2 className="font-semibold" data-id="element-1333" data-mp="8lw9vhxr1a1i">{s.title}</h2>
                <p className="mt-1 text-sm text-mist" data-id="element-1334" data-mp="4kub127qv002">{s.text}</p>
              </li>)}
          </ol>
          <p className="mt-10 max-w-lg rounded-xl border border-warn/30 bg-warn/5 p-4 text-sm text-warn" data-id="element-1335" data-mp="3vp11xyo9i5io">
            VCARS no realiza precalificaciones automáticas ni promete aprobación. La decisión final corresponde a la entidad financiera.
          </p>
        </div>
        <div className="card p-5 sm:p-7" data-id="element-1336" data-mp="3m39km9f0smds">
          <CreditForm data-id="element-1337" data-mp="3m4b7db5eexbc" />
        </div>
      </div>

      <section id="seguimiento" className="mt-16 scroll-mt-24 border-t border-line pt-12" aria-labelledby="trk-title" data-id="element-1338" data-mp="375plvk8pvng2">
        <h2 id="trk-title" className="font-display text-2xl font-bold" data-id="element-1339" data-mp="3c3r5c6a21os2">Seguimiento de tu consulta</h2>
        <p className="mb-6 mt-1 text-sm text-mist" data-id="element-1340" data-mp="3oh7xbh417qm">Ingresá tu número de seguimiento y el teléfono que registraste.</p>
        <div className="max-w-3xl" data-id="element-1341" data-mp="8miqlvamj51k">
          <StatusTracker initialCode={code} data-id="element-1342" data-mp="8pocl1nyhqt2" />
        </div>
      </section>
    </div>;
}